import React from "react";
import bgimage from "../../assets/img/Mars-Login7.png";
import logo from "../../assets/img/Mars_icon_white.png";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Home from "../pages/Home";
import Footer from "../reusables/Footer";
import { loginRequest } from "./authConfig";

const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context

  const login = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
      const userEmail = loginResponse && loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse && loginResponse?.idTokenClaims?.name;
      localStorage.setItem("myemail", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
    } catch (error) {
      console.error("Login failed", error);
    }
  };
  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="bg-white dark:bg-gray-900 bgColor">
                <div className="login_body_grid">
                  <div
                    style={{
                      backgroundImage: `linear-gradient(rgba(47,46,53,0.1), rgba(47, 46, 53,0.1)),url(${bgimage})`,
                    }}
                    className="hidden bg-cover lg:block  login_bg_image"
                  >
                    {/* <div className="login_info">
                      <div
                        style={{
                          backgroundColor: "#0000a0",
                          width: "75%",
                          display: "block",
                          margin: "auto",
                          height: "156px",
                          alignContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            textTransform: "capitalize",
                            fontSize: "32px",
                            fontWeight: "600",
                            width: "80%",
                            display: "block",
                            margin: "auto",
                            paddingLeft: "2rem",
                            paddingRight: "2rem",
                          }}
                          className="text-4xl font-bold text-white"
                        >
                          Welcome to Mars QMS 2nd Party Audit Web Portal
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div style={{position:"relative"}} className="right_grid_align bgColor">
                  <div style={{color:"white",fontSize:"30px",lineHeight:"48px",width:"75%",margin:"auto",position:"absolute",left:"0px",right:"0px",top:"6%",fontWeight:"600",textTransform:"capitalize"}}>
                      Welcome To MARS QMS 2nd Party
                      Audit Web Portal
                      </div>
                    <div className="flex-1">
                      
                    

                      <div className="text-center">
                        <span className="text-4xl font-bold text-center text-gray-700 dark:text-white MarsLogo">
                          <img width={140} src={logo} alt="img" />
                        </span>

                        <p className="left_grid_text left_margin loginText1 formLableText1">
                          Sign in to access your account
                        </p>
                      </div>

                      <div className="mt-8">
                        <div className="mt-6">
                          <button className="btn_login" onClick={login}>
                            Sign in
                          </button>
                        </div>
                      </div>

                      <div
                        style={{
                          width: "70%",
                          paddingTop: "1rem",
                          display: "block",
                          margin: "auto",
                        }}
                      >
                        <span
                          id="Login_herf"
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {/* <a
                            rel="noreferrer"
                            target={"_blank"}
                            className="loginText1 formLableText1"
                            style={{ textDecoration: "none" }}
                            href="mailto:noreply.qmsaudit@effem.com?subject=Need Access to the  Lab Analytics - SNOW Queries Applications!"
                          >
                            {" "}
                            Need Access?
                          </a> */}

                          <a
                            rel="noreferrer"
                            target={"_blank"}
                            className="loginText1 formLableText1"
                            style={{ textDecoration: "none" }}
                            href="mailto:QMSAudit.AccessRequest@effem.com?subject=Need help signing in to the Mars QMS 2nd Party Audit Web Portal application!"
                          >
                            {" "}
                            Need Access ?
                          </a>
                        </span>
                      </div>
                    </div>

                    <Footer className="LoginTextCls"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
